<template>
  <div v-if="visible">
    <label>{{ label }}</label>
    <small><g-markdown v-if="description" :content="description" /></small>

    <template>
      <textarea
        v-if="longText"
        v-model="value"
        @input="handleChange"
      ></textarea>
      <input v-else v-model="value" @input="handleChange" />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default() {
        return null;
      }
    },
    description: {
      type: String,
      default() {
        return null;
      }
    },
    longText: {
      type: Boolean,
      default() {
        return false;
      }
    },
    characterLimit: {
      type: Number,
      default() {
        return null;
      }
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      value: ''
    };
  },
  watch: {
    visible(newVal, oldVal) {
      if (!newVal) {
        this.value = '';
      }
    }
  },
  methods: {
    handleChange(event) {
      this.$emit('change', event.target.value);
    }
  }
};
</script>

<style scoped>
/* Copied from RadioGroup Component */
label {
  color: #202020;
  display: block;
  font-size: 18px;
  font-weight: 600;
  line-height: 23px;
  margin: 15px 0;
}

textarea {
  appearance: none;
  border: 0;
  font-family: 'Libre Franklin', Helvetica, Arial, sans-serif;
  font-size: 16px;
  height: 90px;
  margin-bottom: 15px;
  padding: 15px;
  resize: none;
  width: 100%;
}

input {
  appearance: none;
  border: 0;
  font-family: 'Libre Franklin', Helvetica, Arial, sans-serif;
  font-size: 16px;
  height: 50px;
  margin-bottom: 15px;
  padding: 15px;
  resize: none;
  width: 100%;
}
</style>
